<template>
  <div class="flex flex-1 flex-col overflow-x-hidden">
    <MTab v-model="currentTab" position="left">
      <MTabPane v-for="tab in allTabs" :key="tab.key" :tab="tab.title">
        <CostTab
          v-if="tab.key === 'cost'"
          :key="currentTab"
          :disabled="disabled"
          :loading="loading"
          :resource-id="resourceId"
          :resource="resource"
          :module-name="moduleName"
          :cost-info="costInfo"
          @refresh="handleRefresh"
        />
        <DepreciationDetailsTab
          v-if="tab.key === 'depreciation_details'"
          :key="currentTab"
          :disabled="disabled"
          :resource-id="resourceId"
          :resource="resource"
          :module-name="moduleName"
          :cost-info="costInfo"
        />
      </MTabPane>
    </MTab>
  </div>
</template>

<script>
import CostTab from './cost-tab'
import DepreciationDetailsTab from './depreciation-details-tab'
import { getAssetDepreciationCostInfoApi } from '../../asset-api'
export default {
  name: 'FinancialTab',
  components: { CostTab, DepreciationDetailsTab },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, defalut: false },
  },
  data() {
    return {
      currentTab: 'cost',
      costInfo: {},
      loading: true,
    }
  },
  computed: {
    allTabs() {
      return [
        { title: this.$tc('cost', 2), key: 'cost' },
        ...(this.moduleName !== this.$constants.ASSET_CONSUMABLE
          ? [
              {
                title: `${this.$tc('depreciation')} ${this.$tc('details')}`,
                key: 'depreciation_details',
              },
            ]
          : []),
      ]
    },
  },
  created() {
    this.getCostInfo()
  },
  methods: {
    getCostInfo() {
      getAssetDepreciationCostInfoApi(this.moduleName, this.resourceId, {
        archived: this.resource.archived,
      }).then((data) => {
        this.costInfo = data
        this.loading = false
      })
    },
    handleRefresh() {
      this.getCostInfo()
    },
  },
}
</script>
